// Operation — Liste des visiteurs AMO avec leurs stats.
import { Users, UserCheck, Loader2 } from "lucide-react";
import { useOperationFetch } from "./useOperationFetch";

export default function OperationVisiteursWidget() {
  const { data, loading } = useOperationFetch();
  if (loading) return <div className="rounded-xl p-5 flex items-center justify-center"
    style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}>
    <Loader2 className="w-5 h-5 animate-spin" style={{ color: "var(--oh-text-muted)" }} /></div>;

  const items = data?.par_visiteur || [];

  return (
    <div className="rounded-xl p-5" style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}
      data-testid="operation-visiteurs-widget">
      <h3 className="font-semibold mb-4 flex items-center gap-2" style={{ color: "var(--oh-text)" }}>
        <Users className="w-4 h-4 text-blue-500" />
        Visiteurs AMO ({items.length})
      </h3>
      <div className="space-y-2 max-h-[400px] overflow-y-auto pr-1">
        {items.map((v) => {
          const pct = v.total > 0 ? Math.round((v.payees / v.total) * 100) : 0;
          return (
            <div key={v.visiteur} className="flex items-center gap-3 p-3 rounded-lg"
              style={{ background: "var(--oh-bg-surface)", border: "1px solid var(--oh-border)" }}>
              <div className="p-2 rounded-lg" style={{ background: "var(--oh-stat-blue-bg)" }}>
                <UserCheck className="w-4 h-4" style={{ color: "var(--oh-stat-blue-text)" }} />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold truncate" style={{ color: "var(--oh-text)" }}>{v.visiteur}</p>
                <p className="text-xs" style={{ color: "var(--oh-text-muted)" }}>{v.total} visites</p>
              </div>
              <div className="flex items-center gap-3 text-xs">
                <span style={{ color: "var(--oh-stat-green-text)" }}>{v.payees} payées</span>
                {v.non_payees > 0 && <span style={{ color: "var(--oh-stat-amber-text)" }}>{v.non_payees} en attente</span>}
              </div>
              <span className="text-sm font-bold w-12 text-right" style={{
                color: pct >= 80 ? "var(--oh-stat-green-text)" : pct >= 50 ? "var(--oh-stat-amber-text)" : "var(--oh-stat-red-text)",
              }}>{pct}%</span>
            </div>
          );
        })}
        {items.length === 0 && (
          <div className="text-center py-6 text-xs" style={{ color: "var(--oh-text-muted)" }}>Aucun visiteur</div>
        )}
      </div>
    </div>
  );
}
